import PolicyLayout from "layout/Policy";
import { styled } from "@mui/material/styles";
import TDpolicy from "assets/image/TD-policy-Background-03.png";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

const Title = styled(`div`)`
  font-size: 3.875rem;
  line-height: 120%;
  /* or 74px */
  letter-spacing: -0.5px;
  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  padding-top: 224px;
  margin-bottom: 95px;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding-left: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-top: 80px;
    padding-left: 9px;
    font-size: 2rem;
    margin-bottom: 40px;
  }
`;
const Subtitle = styled(`div`)`
  font-size: 1.125rem;
  line-height: 150%;
  /* or 27px */
  letter-spacing: 0.15px;

  /* Text/Secondary */
  color: #707070;
  white-space: pre-line;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding-left: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-left: 9px;
    font-size: 0.875rem;
  }
`;
const ContainerPolicy = styled(`div`)`
  padding: 95px;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding: 9px;
    margin-bottom: 40px;
  }
`;

const PolicyHeader = styled(`div`)`
  font-weight: 700;
  font-size: 3.125rem;
  line-height: 160%;
  /* or 35px */
  letter-spacing: 0.15px;

  /* Primary/Main */
  color: #1f7b44;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-top: 56px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;
const SpaceHeader = styled(`div`)`
  color: #707070;
  padding-top: 61px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-top: 21px;
  }
  * {
    white-space: pre-line !important;
  }
`;

const Header = styled(`div`)`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 123.5%;
  /* or 44px */
  letter-spacing: 0.25px;

  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
  }
`;

const SubDescription = styled(`div`)`
  font-weight: 500;
  font-size: 1rem;

  /* or 27px */
  letter-spacing: 0.15px;

  /* Text/Primary */
  color: #707070;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;

const BgMask = styled(`div`)`
  background: linear-gradient(
    11deg,
    #fafafa 60%,
    rgba(230, 230, 230, 0.630208) 119.16%,
    rgba(196, 196, 196, 0) 160.19%
  );
  width: 100vw;
  height: 886px;
`;
const Bg = styled(`div`)`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: url(${TDpolicy});
    top: 0px;
    width: 100vw;
    height: 885px;
    background-size: contain;
    background-repeat: repeat;
  }
`;
const Strong = styled(`span`)`
  font-weight: 600;
  font-size: 1.125rem;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;
const StrongTitle = styled(`span`)`
  font-weight: 600;
  font-size: 1.125rem;
  color: #000000;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;
export default function PolicyPage() {
  const { t } = useTranslation(["policy"]);
  return (
    <PolicyLayout>
      <Title>{t("policy_title")}</Title>

      <Bg>
        <BgMask />
      </Bg>
      <Subtitle>{t("policy_desc")}</Subtitle>
      <ContainerPolicy>
        <PolicyHeader>{t("definitions")}</PolicyHeader>

        {t("policy_detail", { returnObjects: true })?.map((item, index) => (
          <SpaceHeader key={"title" + index} id={item.id}>
            <Divider sx={{ marginBottom: "21px" }} />

            <Header>{item.title}</Header>

            <ul>
              {item?.describe?.map((itemdescription, subindex) => (
                <li key={"subtitle" + subindex}>
                  <Strong>{itemdescription?.strong}</Strong>
                  {itemdescription?.detial}
                  {itemdescription?.list && (
                    <ul>
                      {itemdescription.list.map((sub_list, index) => (
                        <li key={index} style={{ listStyle: "disc" }}>
                          {sub_list}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>

            {item?.describe_detail?.map((desc, subindex) => (
              <div key={"desc" + subindex}>
                <div>{desc?.title}</div>
                <ul>
                  {desc?.subdetail?.map((desc_sub, subindex) => (
                    <li key={"subtitle" + subindex}>
                      <Strong>{desc_sub?.strong}</Strong>
                      {desc_sub?.describe}
                      {desc_sub?.list && (
                        <ul>
                          {desc_sub?.list?.map((list_item, subindex) => (
                            <li key={subindex} style={{ listStyle: "disc" }}>
                              {list_item}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            {item?.type === "contact" && (
              <div>
                <div>{item?.desc}</div>
                <div
                  style={{
                    marginLeft: "40px",
                    marginTop: "60px",
                    marginBottom: "60px",
                  }}
                >
                  <div>
                    <StrongTitle>{item?.sub}</StrongTitle>
                  </div>
                  <div style={{ marginTop: "20px" }}>{item?.address}</div>
                  <div style={{ marginTop: "20px" }}>{item?.email}</div>
                  <a
                    style={{
                      marginTop: "20px",
                      color: "#1F7B44",
                      textDecoration: "underling",
                    }}
                  >
                    {item?.web}
                  </a>
                  <div style={{ marginTop: "20px" }}>{item?.tel}</div>
                  <div style={{ marginTop: "20px" }}>
                    <StrongTitle>{item?.position}</StrongTitle>
                  </div>
                  <div style={{ marginTop: "20px" }}>{item?.address2}</div>
                  <div style={{ marginTop: "20px" }}>{item?.email2}</div>
                </div>
              </div>
            )}
          </SpaceHeader>
        ))}
        <div>
          <SubDescription>
            This Privacy Policy was last updated and effective on 5th February
            2022
            <br />
            I have read and fully understand this Privacy Policy, therefore I
            sign this paper to give consent to the Company
            <br /> to collect, use, and disclosure of my personal data and
            sensitive personal data
          </SubDescription>
        </div>
      </ContainerPolicy>
    </PolicyLayout>
  );
}
